module.exports = __webpack_public_path__ + "static/img/a034.582a421.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a034.jpg
// module id = RQ6g
// module chunks = 0